import React from 'react';
import { Box, Flex, Image, Button, Text } from '@chakra-ui/react';
import Logo from '../GitEventComponent/LogoWhite.svg';
import banner from '../GitEventComponent/banner.jpeg';
import git from '../GitEventComponent/git.png';
import speaker from '../GitEventComponent/speaker.jpeg';
// import Logo from '../GitEventComponent/LogoBlack.svg'

const GitEvent = () => {
  return (
    <>
      <Flex pt={'2rem'} justify={'center'} background={'#170F1E'}>
        <Image
          boxShadow={'3px 3px 18px 0.4px #9092FF'}
          borderRadius={'10px'}
          width={'75%'}
          src={banner}
          m={'0.4rem 0rem'}
        ></Image>
      </Flex>

      <Flex
        flexWrap={'wrap'}
        background={'#170F1E'}
        p={'1rem'}
        alignItems="center"
        justify={'space-evenly'}
        pt={'5rem'}
      >
        <Box mx={{sm:"2rem",lg:"4rem"}}>
          <Image src={Logo}></Image>
        </Box>
        <Box
          m={'2rem 0rem'}
          color={'#E5E1E6'}
          fontSize={{ base:"1rem",sm: '1.4rem', lg: '3rem' }}
          fontWeight={'bold'}
        >
          <Flex alignItems={'center'} direction={'column'}>
            <Text>MLSC VIT, PUNE</Text>
            <Text>X</Text>
            <Text>HACKTOBERFEST 2022</Text>
          </Flex>
        </Box>
      </Flex>
      <Flex
        flexDirection={'column'}
        alignItems={'center'}
        background={'#170F1E'}
        justify={'center'}
        p={'2rem'}
      >
        <a
          // eslint-disable-next-line
          rel="noreferrer"
          href="https://forms.gle/vECYspehenH13EnT9"
          target={'_blank'}
        >
          <Button
            m={'0rem 0rem'}
            width={{ lg: '500px', sm: '200px' }}
            sm
            backgroundColor={'#9092FF'}
            fontSize={{}}
          >
            Register Now!
          </Button>
        </a>
        <Box
          fontSize={{ base: '15px',lg:"1.3rem"}}
          mx={{ lg: '2rem 2rem', sm: '0rem' }}
          p={{ lg: '0rem 4rem', sm: '0rem' }}
          color={'#E5E1E6'}
          textAlign={'center'}
          my={'6rem'}
        >
          Ever wanted to explore more about Opensource? If yes, Then you've come
          to the right place🥳
          <br />
          MLSC VIT Pune is delighted to announce it's latest event revolving
          around Opensource. This event will be a comprehensive guide needed to
          succeed in this space. It will be comprised of tutorials required to
          master Git/GitHub. The event will also give you the roadmap to
          participate in famous Opensource events like hacktoberfest and google
          summer of code (GSoC) from speakers who've been there and done that.
          <br />
          Excited to explore more?🤩 <br />
          Then what you're waiting for , Register Now!
        </Box>
      </Flex>

      <Flex flexWrap={'wrap'} background={'#170F1E'} justify={'space-evenly'}>
        <Box
          m={'2rem 0rem'}
          boxShadow={'3px 3px 18px 0.4px #9092FF'}
          backgroundColor={'#FFE27D'}
        >
          <Box
            w={'16rem'}
            maxW="sm"
            borderWidth="1px"
            borderRadius="lg"
            overflow="hidden"
          >
            <Image
              w={'100%'}
              h={'300px'}
              src={speaker}
              alt={'property.imageAlt'}
            />

            <Box p="6">
              <Box display="flex" alignItems="baseline">
                <Box
                  color="gray.500"
                  fontWeight="semibold"
                  letterSpacing="wide"
                  fontSize="xs"
                  textTransform="uppercase"
                  ml="2"
                ></Box>
              </Box>

              <Box
                mt="1"
                fontWeight="semibold"
                as="h4"
                lineHeight="tight"
                noOfLines={1}
              >
                Open Source Guidance Session.
              </Box>

              <Box>
                3rd October 2022
                <Box as="span" color="gray.600" fontSize="sm">
                  - 5pm Onwards
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>

        <Box
          m={'2rem 0rem'}
          boxShadow={'3px 3px 18px 0.4px #9092FF'}
          backgroundColor={'#FFE27D'}
        >
          <Box
            w={'16rem'}
            maxW="sm"
            borderWidth="1px"
            borderRadius="lg"
            overflow="hidden"
          >
            <Image h={'280px'} w={'100%'} src={git} alt={'property.imageAlt'} />

            <Box p="6">
              <Box display="flex" alignItems="baseline">
                <Box
                  color="gray.500"
                  fontWeight="semibold"
                  letterSpacing="wide"
                  fontSize="xs"
                  textTransform="uppercase"
                  ml="2"
                ></Box>
              </Box>

              <Box
                mt="1"
                fontWeight="semibold"
                as="h4"
                lineHeight="tight"
                noOfLines={1}
              >
                Git and Github Session
              </Box>

              <Box>
                3rd October 2022
                <Box as="span" color="gray.600" fontSize="sm">
                  - 6pm Onwards
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Flex>
    </>
  );
};

export default GitEvent;
